/*
  Stoffeya share icon (snippets/stoffeya-share-button.liquid).
  Touch devices get the phone's own share menu; with a mouse the link is
  copied and a short "Link kopiert" appears, because desktop share sheets
  are unfamiliar and differ per browser.
*/
if (!customElements.get('stoffeya-share-button')) {
  customElements.define(
    'stoffeya-share-button',
    class StoffeyaShareButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.toast = this.querySelector('.share-icon__toast');
        this.button?.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        clearTimeout(this.toastTimer);
      }

      onClick = async () => {
        const url = this.dataset.url || window.location.href;
        const touch = window.matchMedia('(pointer: coarse)').matches;

        if (touch && navigator.share) {
          try {
            await navigator.share({ title: this.dataset.title, url });
            window.posthog?.capture?.('product_share', { method: 'share_sheet' });
          } catch (error) {
            // Closing the share menu rejects too; nothing to do
          }
          return;
        }

        if (await this.copy(url)) {
          this.showToast();
          window.posthog?.capture?.('product_share', { method: 'copy_link' });
        }
      };

      async copy(text) {
        try {
          await navigator.clipboard.writeText(text);
          return true;
        } catch (error) {
          // Older browsers and non-secure contexts: copy through a hidden field
          const field = document.createElement('textarea');
          field.value = text;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.select();
          const copied = document.execCommand('copy');
          field.remove();
          return copied;
        }
      }

      showToast() {
        if (!this.toast) return;
        this.toast.hidden = false;
        clearTimeout(this.toastTimer);
        this.toastTimer = setTimeout(() => {
          this.toast.hidden = true;
        }, 2000);
      }
    }
  );
}
